import { type FunctionComponent } from "react";
import { useDispatch } from "react-redux";
import { Role } from "@App/types/ayvens/role";
import type { AuthApi } from "@App/apis/rest/ayvens/auth/interfaces";
import LoginForm from "@App/Components/organisms/whitelabel/ayvens/LoginForm";
import { setInitialRole, setUserId } from "@App/state/reducers/auth";
import { useTranslation } from "react-i18next";

export type LoginProps = {
  authApi: AuthApi;
  onSuccessfulLogin: () => void;
};

export const Login: FunctionComponent<LoginProps> = ({
  authApi,
  onSuccessfulLogin,
}: LoginProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const attemptLogin = async (
    email: string,
    password: string,
  ): Promise<null | {
    emailError?: string;
    passwordError?: string;
  }> => {
    try {
      const userId = await authApi.login(email, password);
      dispatch(setUserId(userId));
      dispatch(setInitialRole(Role.AGENT));
      onSuccessfulLogin?.();
      return null;
    } catch (error) {
      console.error(error);
      return {
        emailError: t("login.validations.failedLogin"),
        passwordError: t("login.validations.failedLogin"),
      };
    }
  };

  return (
    <div className={"min-h-screen"}>
      <LoginForm onSubmit={attemptLogin} />
    </div>
  );
};
